/* eslint-disable eqeqeq */
import moment from 'moment';
import CRMAudioWave from './CRMAudioWave';
import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Lid sifati: Issiq / Iliq / Sovuq
const LEAD_QUALITY = {
  issiq: { label: 'Issiq', icon: '🔥', cls: 'bg-red-50 text-red-600 border-red-200' },
  iliq: { label: 'Iliq', icon: '🌤', cls: 'bg-amber-50 text-amber-600 border-amber-200' },
  sovuq: { label: 'Sovuq', icon: '❄️', cls: 'bg-blue-50 text-blue-600 border-blue-200' },
};

const AiPanel = ({ data }) => {
  const [open, setOpen] = useState(false);
  if (!data?.ai_status) return null;
  const q = LEAD_QUALITY[data?.ai_lead_status];
  return (
    <div className='mt-2 rounded-lg border border-[#E5E9EB] bg-[#FAFAFE] p-2'>
      <div className='flex items-center gap-2 flex-wrap'>
        <span className='text-[11px] font-semibold text-purple-600 bg-purple-50 px-2 py-0.5 rounded'>
          <i className='bi bi-robot mr-1' />
          AI tahlili
        </span>
        {q && (
          <span
            className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-xs font-semibold ${q.cls}`}
          >
            <span>{q.icon}</span>
            {q.label}
          </span>
        )}
        {data?.ai_score != null && (
          <span className='text-xs text-gray-600'>
            Ball: <b>{data.ai_score}</b>
          </span>
        )}
        {data?.ai_greeted != null && (
          <span className='text-xs text-gray-500'>
            {data.ai_greeted ? 'Salomlashgan ✓' : 'Salomlashmagan ✗'}
          </span>
        )}
        {data?.ai_status !== 'done' && (
          <span className='text-xs text-amber-500'>({data.ai_status}…)</span>
        )}
      </div>
      {data?.ai_summary && (
        <p className='text-xs text-gray-700 mt-1.5 leading-relaxed'>
          {data.ai_summary}
        </p>
      )}
      {data?.ai_lead_reason && (
        <p className='text-[11px] text-gray-500 mt-1'>
          <i className='bi bi-info-circle mr-1' />
          {data.ai_lead_reason}
        </p>
      )}
      {data?.ai_full_text && (
        <div className='mt-1.5'>
          <button
            type='button'
            onClick={() => setOpen((o) => !o)}
            className='text-[11px] text-blue-600 hover:underline'
          >
            {open ? 'Umumiy textni yashirish' : 'Umumiy textni ko‘rish'}
            <i className={`bi bi-chevron-${open ? 'up' : 'down'} ml-1`} />
          </button>
          {open && (
            <div className='mt-1 text-[11px] text-gray-700 bg-white rounded-md p-2 max-h-52 overflow-y-auto whitespace-pre-line border border-[#EEE]'>
              {data.ai_full_text}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const CRMCallAudioMessage = ({ data = {} }) => {
  const { t } = useTranslation();

  return (
    <div className='call-history-wrapper flex items-center'>
      {data?.accountcode == 'outbound' ? (
        <div className='call-icon text-base leading-4 bg-[#48A8FD33] text-[#1290FF] rounded-full w-[42px] h-[42px] min-w-[42px] min-h-[42px] flex items-center justify-center mr-3'>
          <i className='bi bi-telephone-outbound leading-4' />
        </div>
      ) : data?.accountcode == 'inbound' && data?.user_talk_time === 0 ? (
        <div className='call-icon text-base leading-4 bg-[#FDAA484D] text-[#FF8A00] rounded-full w-[42px] h-[42px] min-w-[42px] min-h-[42px] flex items-center justify-center mr-3'>
          <i className='bi bi-telephone-x leading-4' />
        </div>
      ) : data?.accountcode == 'inbound' ? (
        <div className='call-icon text-base leading-4 bg-[#16BA5C33] text-[#16BA5C] rounded-full w-[42px] h-[42px] min-w-[42px] min-h-[42px] flex items-center justify-center mr-3'>
          <i className='bi bi-telephone-inbound leading-4' />
        </div>
      ) : (
        ''
      )}
      <div className='call-details w-full'>
        <div className='text-[12px] text-gray-500'>
          {moment(data?.start_stamp * 1000).format('DD.MM.YYYY HH:mm')},{' '}
          {t('crm.leadHistory.talkDuration')}:&nbsp;
          <span className='text-blue-600 font-semibold'>
            {moment.utc(data?.user_talk_time * 1000).format('mm:ss')}
          </span>
          {data?.accountcode == 'outbound' ? (
            <span className='ml-1'>
              {t('crm.leadHistory.outbound')}:{' '}
              {data?.outbound &&
              data?.outbound?.user &&
              data?.outbound?.user?.name ? (
                <span>
                  {data?.outbound?.user?.name}({data?.outbound?.number}){' '}
                  {data?.type_id == 2
                    ? t('crm.leadHistory.from')
                    : t('crm.leadHistory.s')}
                </span>
              ) : (
                ''
              )}{' '}
              {data?.gateway ? `"${data?.gateway}"` : ''}{' '}
              {data?.type_id == 2 ? '' : t('crm.leadHistory.fromNumber')}
              {data?.destination_number
                ? `"${data?.destination_number}"`
                : ''}{' '}
              {t('crm.leadHistory.toNumber')}
            </span>
          ) : data?.accountcode == 'inbound' ? (
            <span className='ml-2'>
              {data?.user_talk_time === 0 ? (
                <>"{t('crm.leadHistory.missed')}"</>
              ) : (
                <>"{t('crm.leadHistory.inbound')}"</>
              )}
              : "{data?.caller_id_name ? data?.caller_id_name : ''}"{' '}
              {t('crm.leadHistory.from')}{' '}
              {data?.inbound &&
              data?.inbound?.user &&
              data?.inbound?.user?.name ? (
                <span>
                  {data?.inbound?.user?.name}({data?.inbound?.number}){' '}
                  {t('crm.leadHistory.s')}
                </span>
              ) : (
                ''
              )}{' '}
              "{data?.gateway ? data?.gateway : ''}"{' '}
              {t('crm.leadHistory.toNumber')}
            </span>
          ) : (
            ''
          )}
        </div>
        <div className='mt-2'>
          {data?.accountcode == 'inbound' && data?.user_talk_time === 0 ? (
            <>"{t('crm.leadHistory.missed')}"</>
          ) : (
            <CRMAudioWave callId={data?.id} />
          )}
        </div>
        <AiPanel data={data} />
      </div>
    </div>
  );
};
export default memo(CRMCallAudioMessage);
